// @ts-check

import React, { useState } from "react";

import {
  BlockStack,
  Text,
  InlineStack,
  ButtonGroup,
  Button,
  Box,
  Collapsible,
  Tooltip,
  Spinner,
  Image,
} from "@shopify/polaris";
import { CheckIcon } from "@shopify/polaris-icons";

import { OUTLINE_SVG } from "./util.jsx";

import "./ConnectableAccountOnboarding.css";

export const OnboardingStep = ({
  title,
  description,
  primaryButton,
  secondaryButton = null,
  index,
  loading = false,
  complete = false,
  expanded = false,
  setExpanded,
}) => {
  let classes = "setup-item";
  if (expanded) {
    classes += " setup-item-expanded";
  };

  let completeButtonContent;
  if (loading) {
    completeButtonContent = <Spinner size="small" />;
  } else if (complete) {
    completeButtonContent = (
      <CheckIcon
        style={{
          width: '1.25rem',
          height: '1.25rem',
          borderRadius: '100%',
          background: '#303030',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          fill: 'white'
        }}
      />
    );
  } else {
    completeButtonContent = OUTLINE_SVG;
  }

  return (
    <Box borderRadius="200" background={expanded && 'bg-surface-active'}>
      <div className={classes}>
        <InlineStack gap='200' align='start' blockAlign='start' wrap={false}>
          <div className="complete-button">
            {completeButtonContent}
          </div>

          <div
            className="item-content"
            onClick={expanded ? () => null : setExpanded}
            style={{
              cursor: expanded ? "default" : "pointer",
              paddingTop: '.15rem',
              width: "100%",
            }}
          >
            <BlockStack gap="300" id={index}>
              <Text as="h4" variant={expanded ? 'headingSm' : 'bodyMd'}>
                {title}
              </Text>

              <Collapsible open={expanded} id={index}>
                <Box paddingBlockEnd='150' paddingInlineEnd='150'>
                  <BlockStack gap='400'>
                    {description}

                    <ButtonGroup>
                      {primaryButton ? (
                        <Button variant='primary' {...primaryButton.props}>
                          {primaryButton.content}
                        </Button>
                      ) : null}
                      {secondaryButton ? (
                        <Button variant='tertiary' {...secondaryButton.props}>
                          {secondaryButton.content}
                        </Button>
                      ) : null}
                    </ButtonGroup>
                  </BlockStack>
                </Box>
              </Collapsible>
            </BlockStack>
          </div>
        </InlineStack>
      </div>
    </Box>
  );
};
